module.exports = __webpack_public_path__ + "img/93.aac9c848.jpg";